module.exports = __webpack_public_path__ + "static/media/decimo_logo.c6f03816.png";